import React from 'react'
import { Helmet } from 'react-helmet'
import '../../../styles/Pages/Auth/forgotPassword.style.css'
import LeftTemp from '../../../components/Auth/LeftTemp'
import logo from '../../../assets/Images/loginImg/Login_logo.png'
import arrow from '../../../assets/Icons/Pages/Auth/BsArrowRight.svg'

const Body = () => {
    return (
        <div className='forgot-password-body'>
            <Helmet>
                <title>Forgot Password - OMS</title>
            </Helmet>
            <div className='forgot-password-left-container'>
                <LeftTemp />
            </div>
            <div className='forgot-password-right-container'>
                <h3>Forgot Password</h3>
                <div className='forgot-password-form'>
                    <img src={logo} alt="Logo" />
                    <div className='forgot-password-form-wrapper'>
                        <div className='email-container'>
                            <label htmlFor="Email">Email</label>
                            <input type="email" placeholder="Enter your Email" name='email' />
                        </div>
                        <button>Next</button>
                        <img src={arrow} alt="" className='arrow' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Body
